import { render } from "./FilmDetail.vue?vue&type=template&id=963e37ca&scoped=true"
import script from "./FilmDetail.vue?vue&type=script&lang=js"
export * from "./FilmDetail.vue?vue&type=script&lang=js"

import "./FilmDetail.vue?vue&type=style&index=0&id=963e37ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963e37ca"]])

export default __exports__